export default __webpack_public_path__ + "static/media/4-DTG-Fair.21b29fc7.jpg";